import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, catchError, takeUntil, finalize, tap, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { SettingService } from './setting.service';
import { AuthService } from './auth.service';

export interface movements {
  Tipoabt?: string,
  operadorABT?: string,
  codigotipotrx?: number,
  nombreTRX?: string,
  fecha_trx?: string,
  fecha_ajuste?: string,
  codproducto?: number,
  nombreproducto?: string,
  operador?: string,
  estacion?: string,
  servicio?: string,
  MONTO_ABONO?: number,
  MONTO_DESCUENTO?: number
}
export interface ConsultaAbtServicio {
  estado: number;
  mensaje: string;
  saldo: string;
  estadoCuenta?: string;
  estadoVigencia: string;
  listaTransacciones: movements[];
  nombreEstudiante?: string;
  numabt?: string;
  numtarjetaExt?: string;
  tipoCuenta?: string;
  tipoEstudiante?: string;
}

export interface ValidadorMAResponse {
  resultado: number;
  mensaje: string;
  estadoMA?: number;
  descripcion?: string;
  tecnologia?: number;
  uidtarjeta?: number;
  tipotarjeta?: number;
  descTipoTarjeta?: string;
  numABT?: string;
  numeroInterno?: number | string;
  numeroExterno?: number | string;
  uuidMovil?: string;
  nombres?: string;
  apellidos?: string;
  correo?: string;
  rut?: string;
}
export interface consultaAbtResp {
  estado: { numeroError: number; mensajeError: string } | null;
  servicio: ConsultaAbtServicio;
}
export interface Estado {
  mensajeError: string;
  numeroError: number;
}
export interface creaSolicitudRes {
  estado: Estado
}

@Injectable({
  providedIn: 'root'
})
export class TarjetasService {
  constructor(private http: HttpClient, 
    private settingsService: SettingService, 
    private auth: AuthService) 
    {}

  usuario = this.settingsService.settings.ipFyService;
  pocaeBackend = this.settingsService.settings.ipFyService;
  pocaeHitorial = this.settingsService.settings.pocaeHistorial;
  soap = this.settingsService.settings.Soap;
  solicitud = this.settingsService.settings.ipFyService;
  abt = this.settingsService.settings.abt;

  // estado interno
  error: any;
  card: { cards: any[] } = { cards: [] }
  numCard = ''

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    })
  }

  private tarjeta = new BehaviorSubject(this.card);
  currentTarjeta = this.tarjeta.asObservable();

  private sCard = new BehaviorSubject(this.numCard);
  selectedCard = this.sCard.asObservable();

  // subject para cancelar peticiones en vuelo
  private cancel$ = new Subject<void>();

  addCards(cards: any[]) {
    this.card = { cards: cards };
    this.tarjeta.next(this.card)
  }

  clearCards() {
    this.card = { cards: [] };
    this.tarjeta.next(this.card);
  }

  selectCard(numCard: string) {
    this.numCard = numCard;
    this.sCard.next(this.numCard)
  }

  // Método para cancelar peticiones en curso (llamar en logout / cambio de usuario)
  cancelRequests() {
    try {
      this.cancel$.next();
      this.cancel$.complete();
    } finally {
      // volver a crear para futuros usos
      this.cancel$ = new Subject<void>();
    }
  }

  // Handler de errores centralizado y "normalizado"
  private handleError(err: any) {
    // Si el backend devuelve objeto en err.error, preferirlo
    const normalized = err?.error ?? err;
    return throwError(() => normalized);
  }

  getCards(json: any) {
    return this.http.post(this.usuario + '/RCAEBack/pocae/usuario/tarjeta/resumenTarjetas', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  newCard(json: any) {
    return this.http.post(this.usuario + "/RCAEBack/pocae/usuario/tarjeta/afiliar", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  deleteCard(json: any) {
    return this.http.post(this.usuario + "/RCAEBack/pocae/usuario/tarjeta/desafiliar", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  getMovimientos(numTarjeta: string, filter: number | string) {
    return this.http.post(this.usuario + '/usuario/movimientos?numTarjetaExterno=' + numTarjeta + '&cantDias=' + filter, this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  getRadisponible(numTarjeta: string) {
    return this.http.post(this.usuario + '/usuario/resumenra?numTarjetaExterno=' + numTarjeta, this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  getSolicitudes(body: any) {
    return this.http.post(this.solicitud + '/RCAEBack/pocae/solicitud/', body, this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  cargarDinero(json: any) {
    return this.http.post(this.soap + '/SOAPtoREST/visanet/venta', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  tagCard(json: any) {
    return this.http.post(this.usuario + '/usuario/tarjeta/actualizar', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  favCard(json: any) {
    return this.http.post(this.usuario + '/usuario/tarjeta/favorita', JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  sendData(json: any) {
    return this.http.post(this.solicitud + "/PocaeSolicitud/enviaSolicitudABT", JSON.stringify(json), this.httpOptions)
      .pipe(catchError(this.handleError.bind(this)));
  }

  getDetalle(json: any) {
    return this.http.post(this.usuario + "/RCAEBack/pocae/solicitud/detalle", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  verificaSolicitudEnCurso(json: any) {
    return this.http.post(this.solicitud + "/PocaeSolicitud/verificaCantSolicitud", JSON.stringify(json), this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  cargaParametrosSol() {
    return this.http.get(this.solicitud + "/PocaeSolicitud/cargaParametrosSol", this.httpOptions)
      .pipe(retry(4), catchError(this.handleError.bind(this)));
  }

  // ---- ABT ----

   getTransaccionesAbt(body: any) {
    return this.http.post<any>(`${this.pocaeBackend}/RCAEBack/pocae/consulta/movimientos`, body)
      .pipe(
        takeUntil(this.auth.cancelPendingRequests$),
       
        catchError(err => {
          return throwError(() => err);
        })
      );
  }

  getDetail(body: any) {
    return this.http.post(`${this.abt}/recaudowsrest/producto/consultaCuentas`, body)
      .pipe(takeUntil(this.cancel$), catchError(this.handleError.bind(this)));
  }

  bloqCardPocae(body: any) {
    return this.http.post<creaSolicitudRes>(this.solicitud + '/PocaeSolicitud/enviaSolicitudBloqueo', body)
      .pipe(catchError(this.handleError.bind(this)));
  }

  bloqCard(body: any, options?: { headers?: HttpHeaders, [key: string]: any }) {
    return this.http.post<creaSolicitudRes>(this.pocaeBackend + '/RCAEBack/pocae/solicitud/crear', body, options)
      .pipe(catchError(this.handleError.bind(this)));
  }

  validacionMA(nTarjeta: string) : Observable<ValidadorMAResponse & { numeroInternoStr?: string }> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'SUBJECT_CONTENT': 'CN=OP.152, OU=transporte, O=sonda, L=santiago, ST=santiago, C=CL ;OU=transporte, O=sonda, L=santiago, ST=santiago, CN=AP.3, C=CL'
  });

  const body = {
    codigoOperador: 152,
    codigoApp: 3,
    tipoMedioAcceso: 'TAG',
    tipoValidacion: 2,
    idMedioAcceso: nTarjeta
  };

  // pedimos respuesta como texto para preservar dígitos grandes
  return this.http.post(`${this.pocaeBackend}/pagomovil/5/rest/servicios/validacionMA`, body, { headers, responseType: 'text' })
    .pipe(
      takeUntil(this.cancel$),
      map((raw: string) => {
        // intentamos parsear JSON para el resto de campos
        let parsed: any = {};
        try {
          parsed = JSON.parse(raw);
        } catch (e) {
          // si no es JSON válido devolvemos objeto con mensaje crudo
          parsed = { resultado: -1, mensaje: raw };
        }

        // EXTRAEMOS numeroInterno tal cual del texto (regex que captura la secuencia de dígitos)
        const m = raw.match(/"numeroInterno"\s*:\s*([0-9]+)/); // sin comillas en valor
        const mQuoted = raw.match(/"numeroInterno"\s*:\s*"([0-9]+)"/); // si viene como string con comillas
        const numeroInternoStr = (mQuoted && mQuoted[1]) ? mQuoted[1] : (m && m[1]) ? m[1] : (parsed.numeroInterno ? String(parsed.numeroInterno) : undefined);

        // adjuntamos la cadena exacta
        return Object.assign({}, parsed, { numeroInternoStr });
      }),
      catchError(this.handleError.bind(this))
    );
}
}
